module.exports = __webpack_public_path__ + "static/media/plus_blue.cb80a6d0.svg";